import React, { useEffect, useState } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import Login from './Login';

const Heading = () => {
  const isNavigatorOnline = !!navigator.onLine;
  const [isOnline, setOnline] = useState(isNavigatorOnline);

  useEffect(() => {
    const handleOnlineStatus = ({ type }) => {
      setOnline(type === 'online');
    };

    window.addEventListener('offline', handleOnlineStatus);
    window.addEventListener('online', handleOnlineStatus);

    return () => {
      window.removeEventListener('offline');
      window.removeEventListener('online');
    };
  }, []);

  return (
    <div>
      <Segment
        className="remove-header-radius"
        color={isOnline ? 'grey' : 'red'}
        inverted
        clearing
      >
        {isOnline ? (
          <Header
            as="h1"
            color="black"
            floated="left"
            className="app-title margin-0"
          >
            Praćenje pošiljki BiH
          </Header>
        ) : (
          <Header
            as="h1"
            textAlign="center"
            floated="left"
            className="app-title margin-0"
          >
            Praćenje pošiljki BiH — Van mreže
          </Header>
        )}
        <Header as="h3" color="black" floated="right" className="margin-0">
          <Login />
        </Header>
      </Segment>
    </div>
  );
};

export default Heading;
